import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { Company, Person } from "@mapmycustomers/shared/types/entity";
import Route, { RouteManualStop, RoutePreview } from "@mapmycustomers/shared/types/entity/Route";
import { EntityTypesSupportingRoutes } from "@mapmycustomers/shared/types/entity/types";
import User from "@mapmycustomers/shared/types/User";

import { RoutePatch } from "@app/scene/routes/utils/mergeRoute";

export const deleteRoute = createAsyncAction(
  "route/routeDetails/deleteRoute/request",
  "route/routeDetails/deleteRoute/success",
  "route/routeDetails/deleteRoute/failure"
)<void, void, void>();

export const rebuildRoutePreview = createAsyncAction(
  "route/routeDetails/view/rebuildRoutePreview/request",
  "route/routeDetails/view/rebuildRoutePreview/success",
  "route/routeDetails/view/rebuildRoutePreview/failure"
)<void, { route: Route; routePreview?: RoutePreview }, void>();

export const resetAllStops = createAsyncAction(
  "route/routeDetails/view/resetAllStops/request",
  "route/routeDetails/view/resetAllStops/success",
  "route/routeDetails/view/resetAllStops/failure"
)<void, { route: Route; routePreview?: RoutePreview }, void>();

export const setRoute = createAction("route/routeDetails/view/setRoute")<{
  route: Route;
  routePreview?: RoutePreview;
}>();

export const setRouteStopChecked = createAsyncAction(
  "route/routeDetails/setStopChecked/request",
  "route/routeDetails/setStopChecked/success",
  "route/routeDetails/setStopChecked/failure"
)<
  {
    checkedOff: boolean;
    entityId: Company["id"] | Person["id"] | RouteManualStop["id"];
    entityType: EntityTypesSupportingRoutes | null;
  },
  { route: Route },
  void
>();

export const shareRoute = createAsyncAction(
  "route/routeDetails/shareRoute/request",
  "route/routeDetails/shareRoute/success",
  "route/routeDetails/shareRoute/failure"
)<{ userIds: User["id"][] }, { route: Route }, void>();

export const updateRoute = createAsyncAction(
  "route/routeDetails/updateRoute/request",
  "route/routeDetails/updateRoute/success",
  "route/routeDetails/updateRoute/failure"
)<{ patch: RoutePatch }, { route: Route; routePreview?: RoutePreview }, void>();

export type ViewActions = ActionType<
  | typeof deleteRoute
  | typeof rebuildRoutePreview
  | typeof resetAllStops
  | typeof setRoute
  | typeof setRouteStopChecked
  | typeof shareRoute
  | typeof updateRoute
>;
